import React, { Component } from "react";
import { Button, InputNumber, Modal } from "antd";
import "./index.scss";

class NewValueModal extends Component {
  state = {
    value: null,
  };

  handleChange = (field, value) => {
    this.setState({
      ...this.state,
      [field]: value,
    });
  };

  resetModal = () => {
    this.setState({
      value: null,
    });
  };

  render() {
    const { visible, onCancel, onConfirm } = this.props;
    const { value } = this.state;

    return (
      <Modal
        className="newValueModal"
        title={
          <div className="newValueTitle">
            <h2>Set A New Value</h2>
            <p>Enter new price for all the variants</p>
          </div>
        }
        visible={visible}
        width={320}
        onCancel={onCancel}
        afterClose={this.resetModal}
        footer={[
          <Button key="back" onClick={onCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={(e) => onConfirm(this.state.value)}
          >
            Apply
          </Button>,
        ]}
      >
        <div>
          <InputNumber
            value={value}
            placeholder="Enter new value"
            onChange={(e) => this.handleChange("value", e)}
          />
        </div>
      </Modal>
    );
  }
}

export default NewValueModal;
